import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { buttonEmits } from '../button/button';
import { buttonPresetsProps } from './buttonPresets';
import { UiIconMagickWand, UiIconDeleteOutline, UiIconRefresh, UiIconDownload } from '../../icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'buttonPresets',
  props: buttonPresetsProps,
  emits: buttonEmits,
  setup(__props, { expose, emit: emits }) {

const props = __props



const buttonPresetsTooltipRef = ref();

const getColorScheme = computed(() => {
    switch (props.type) {
        case 'action':
            return 'red';
        case 'create':
        case 'download':
        case 'reload':
            return 'outline';
        case 'trash':
            return 'outline-red';
        default:
            return undefined;
    }
});

const getIcon = computed(() => {
    switch (props.type) {
        case 'create':
            return UiIconMagickWand;
        case 'trash':
            return UiIconDeleteOutline;
        case 'reload':
            return UiIconRefresh;
        case 'download':
            return UiIconDownload;
        default:
            return undefined;
    }
});

const getText = computed(() => {
    switch (props.type) {
        case 'create':
            return 'Создать';
        case 'trash':
            return 'Удалить';
        default:
            return '';
    }
});

const getBind = computed(() => {
    // Свои пропсы в спред не отдаём: ui-button их не объявляет, поэтому они осели бы
    // атрибутами на нативном <button> — в частности type="action", который браузер
    // трактует как type="submit" и внутри формы даёт лишний сабмит.
    const { type, tooltip, tooltipPlacement, isActive, ...restProps } = props;

    return {
        ...restProps,
        icon: getIcon.value,
        colorScheme: getColorScheme.value,
    };
});

expose({
    buttonPresetsTooltipRef,
});

return { __sfc: true,props, emits, buttonPresetsTooltipRef, getColorScheme, getIcon, getText, getBind }
}

})